import { Link } from '@framework/router/Next/Link';
import URL from '@/creditflowresearch/Router/urlConstants';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';
import { useIsGuest } from '@/creditflowresearch/application/User/access/hooks/useIsGuest';
import styles from './managePromptsLink.module.scss';

const ManagePromptsLink = () => {
  const isGuest = useIsGuest();
  const { isSplit, isFullScreen, close } = useAiSidebarContext();

  if (isGuest) {
    return null;
  }

  const handleClick = (): void => {
    if (!isSplit || isFullScreen) close();
  };

  return (
    <Link
      to={ URL.ASK_AI }
      className={ styles.link }
      onClick={ handleClick }
      dataTest="askAiManagePromptsLink"
    >
      Manage prompts
    </Link>
  );
};

export default ManagePromptsLink;
